import { lazy, FC, Suspense } from 'react'
import { Route, Routes, Navigate } from 'react-router-dom'
import { MasterLayout } from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import { getCSSVariableValue } from '../../_metronic/assets/ts/_utils'
import { WithChildren } from '../../_metronic/helpers'
import { PageTitle } from '../../_metronic/layout/core'
import AdminPage from '../pages/admin/AdminPage'
import UserPage from '../pages/user/UserPage'
import AccountPage from '../pages/accounts/AccountPage'
import CategoryPage from '../pages/category/CategoryPage'
import SubcategoryPage from '../pages/subcategory/SubcategoryPage'
import InterestPage from '../pages/interest/InterestPage'
import TourTypePage from '../pages/tourtype/TourTypePage'
import VendorsPage from '../pages/vendors/AccountPage'
import { ViewHotels } from '../pages/hotelmanagement/ViewHotels'
import { AddRestaurantBasicInfo } from '../pages/restaurantmanagement/AddRestaurantBasicInfo'
import { AddRestaurantLocation } from '../pages/restaurantmanagement/AddRestaurantLocation'
import { AddRestaurantDetails } from '../pages/restaurantmanagement/AddRestaurantDetails'
import { AddRestaurantMenu } from '../pages/restaurantmanagement/AddRestaurantMenu'
import { AddRestaurantPhotos } from '../pages/restaurantmanagement/AddRestaurantPhotos'
import { AddRestaurantFacilities } from '../pages/restaurantmanagement/AddRestaurantFacilities'
import { AddRestaurantAvailability } from '../pages/restaurantmanagement/AddRestaurantAvailability'
import { AddRestaurantPolicies } from '../pages/restaurantmanagement/AddRestaurantPolicies'
import { AddRestaurantFinance } from '../pages/restaurantmanagement/AddRestaurantFinance'
import { ViewRestaurant } from '../pages/restaurantmanagement/ViewRestaurant'
import { ViewSpaceRentals } from '../pages/spacerentalmanagement/ViewSpaceRentals'
import { AddSpaceBasicInfo } from '../pages/spacerentalmanagement/AddSpaceBasicInfo'
import { AddSpaceLocation } from '../pages/spacerentalmanagement/AddSpaceLocation'
import { AddSpaceDetails } from '../pages/spacerentalmanagement/AddSpaceDetails'
import { ViewRentableSpaces } from '../pages/spacerentalmanagement/ViewRentableSpaces'
import { AddSpacePhotos } from '../pages/spacerentalmanagement/AddSpacePhotos'
import { AddSpaceFacilities } from '../pages/spacerentalmanagement/AddSpaceFacilities'
import { AddSpaceAvailability } from '../pages/spacerentalmanagement/AddSpaceAvailability'
import { AddSpacePolicies } from '../pages/spacerentalmanagement/AddSpacePolicies'
import { AddSpaceFinance } from '../pages/spacerentalmanagement/AddSpaceFinance'
import { AddHotelBasicInfo } from '../pages/hotelmanagement/AddHotelBasicInfo'
import { AddHotelLocation } from '../pages/hotelmanagement/AddHotelLocation'
import { AddHotelDetails } from '../pages/hotelmanagement/AddHotelDetails'
import { ViewRooms } from '../pages/hotelmanagement/ViewRooms'
import { ViewRoomsList } from '../pages/hotelmanagement/ViewRoomsList'
import { AddHotelPhotos } from '../pages/hotelmanagement/AddHotelPhotos'
import { AddHotelFacilities } from '../pages/hotelmanagement/AddHotelFacilities'
import { AddHotelPolicies } from '../pages/hotelmanagement/AddHotelPolicies'
import { AddHotelFinance } from '../pages/hotelmanagement/AddHotelFinance'
import LoyaltiProgramPage from '../pages/loyaltiprogram/LoyaltiProgramPage'
import { RoomOverview } from '../pages/hotelmanagement/RoomOverview'
import { RoomImages } from '../pages/hotelmanagement/RoomImages'
import { HotelOverview } from '../pages/hotelmanagement/HotelOverview'
import { RestaurantOverview } from '../pages/restaurantmanagement/RestaurantOverview'
import { RestaurantImages } from '../pages/restaurantmanagement/RestaurantImages'
import { SpaceRentalOverview } from '../pages/spacerentalmanagement/SpaceRentalOverview'
import { SpaceImages } from '../pages/spacerentalmanagement/SpaceImages'
import { ViewRentableSpaceList } from '../pages/spacerentalmanagement/ViewRentableSpaceList'
import { RentableSpaceOverview } from '../pages/spacerentalmanagement/RentableSpaceOverview'
import { RentableSpaceImages } from '../pages/spacerentalmanagement/RentableSpaceImages'
import PointSystem from '../pages/loyaltiprogram/PointSystem'
import LevelsPoint from '../pages/loyaltiprogram/LevelsPoint'
import BadgeSystem from '../pages/loyaltiprogram/BadgeSystem'
import Accommodation from '../pages/filters/Accommodation'
import CafeAndResturant from '../pages/filters/CafeAndResturants'
import SpaceRentals from '../pages/filters/SpaceRentals'
import TourPackages from '../pages/filters/TourPackages'
import CarRentals from '../pages/filters/CarRentals'
import FlightTickets from '../pages/filters/FlightTickets'
import TrainTickets from '../pages/filters/TrainTickets'
import LeisureAndTickets from '../pages/filters/LeisureAndTickets'
import { ViewTourPackages } from '../pages/tourpackagemanagement/ViewTourPackages'
import { AddTourPackageBasicInfo } from '../pages/tourpackagemanagement/AddTourPackageBasicInfo'
import { AddTourPackageLocation } from '../pages/tourpackagemanagement/AddTourPackageLocation'
import { ViewTours } from '../pages/tourpackagemanagement/ViewTours'
import { ToursOverview } from '../pages/tourpackagemanagement/ToursOverview'
import { ToursImages } from '../pages/tourpackagemanagement/ToursImages'
import { AddTourPackagePhotos } from '../pages/tourpackagemanagement/AddTourPackagePhotos'
import { AddTourPackagePolicies } from '../pages/tourpackagemanagement/AddTourPackagePolicies'
import { AddTourPackageFinance } from '../pages/tourpackagemanagement/AddTourPackageFinance'
import { TourPackageOverview } from '../pages/tourpackagemanagement/TourPackageOverview'
import { TourPackageImages } from '../pages/tourpackagemanagement/TourPackageImages'
import { ViewToursList } from '../pages/tourpackagemanagement/ViewToursList'

import { ViewCarRentals } from '../pages/transportationmanagement/ViewCarRentals'
import { AddCarRentalBasicInfo } from '../pages/transportationmanagement/AddCarRentalBasicInfo'
import { AddCarRentalLocation } from '../pages/transportationmanagement/AddCarRentalLocation'
import { ViewCars } from '../pages/transportationmanagement/ViewCars'
import { VehicleOverview } from '../pages/transportationmanagement/VehicleOverview'
import { AddCarRentalPhotos } from '../pages/transportationmanagement/AddCarRentalPhotos'
import { AddCarRentalInsurance } from '../pages/transportationmanagement/AddCarRentalInsurance'
import { AddCarRentalDocuments } from '../pages/transportationmanagement/AddCarRentalDocuments'
import { AddCarRentalAvailability } from '../pages/transportationmanagement/AddCarRentalAvailability'
import { AddCarRentalPickupOrDropoffInfo } from '../pages/transportationmanagement/AddCarRentalPickupOrDropoffInfo'
import { AddCarRentalPolicies } from '../pages/transportationmanagement/AddCarRentalPolicies'
import { AddCarRentalFinance } from '../pages/transportationmanagement/AddCarRentalFinance'
import { CarRentalOverview } from '../pages/transportationmanagement/CarRentalOverview'
import { ViewCarsList } from '../pages/transportationmanagement/ViewCarsList'

// booked rental moidules routes

import { ViewTourBooking } from '../pages/bookingtour/ViewTourBooking'
import { ViewHotelBooking } from '../pages/bookinghotel/ViewHotelBooking'
import { ViewSpaceRentalBooking } from '../pages/bookingspacerental/ViewSpaceRentalBooking'
import ViewTravellerIdType from '../pages/travelleridtype/ViewTravellerIdType'
// import { EditHotelBookingDetails } from '../pages/bookinghotel/EditHotelBookingDetails'
import { EditHotelBookingDetails } from '../pages/bookinghotel/EditHotelBookingDetails'
import { EditSpaceBookingDetails } from '../pages/bookingspacerental/EditSpaceBookingDetails'
import { EditTourBookingDetails } from '../pages/bookingtour/EditTourBookingDetails'
import { ViewCoupon } from '../pages/revenuemanagement/coupon/ViewCoupon'
import { ViewHotelBookingDetails } from '../pages/bookinghotel/ViewHotelBookingDetails'
import { ViewSpaceBookingDetails } from '../pages/bookingspacerental/ViewSpaceBookingDetails'
import { ViewTourBookingDetails } from '../pages/bookingtour/ViewTourBookingDetails'

import ViewCategoryWiseEarning from '../pages/revenuemanagement/revenue/ViewCategoryWiseEarning'
import ViewVendorWiseEarning from '../pages/revenuemanagement/revenue/ViewVendorWiseEarning'
import { AdminCommission} from '../pages/revenuemanagement/commission/AdminCommission'
import { ViewAdminVendorPayment } from '../pages/revenuemanagement/adminvendorpayment/ViewAdminVendorPayment'
import { ViewAdminVendorPaymetDetail } from '../pages/revenuemanagement/adminvendorpayment/ViewAdminVendorPaymetDetail'
import { ViewVendorPaymentManagement } from '../pages/revenuemanagement/vendorpaymentmanagement/ViewVendorPaymentManagement'
import { InvoiceWiseVendorPaymentManagement } from '../pages/revenuemanagement/vendorpaymentmanagement/InvoiceWiseVendorPaymentManagement'
import { Invoicedatavendorwise } from '../pages/revenuemanagement/vendorpaymentmanagement/InvoiceDataVendorWise'
import ViewTotalRevenueChart from '../pages/revenuemanagement/revenue/ViewTotalRevenueChart'
import ViewCategoryWiseEarningByYearMonth from '../pages/revenuemanagement/revenue/ViewCategoryWiseEarningByYearMonth'
import { ViewDetailedRevenueReportsByVendor } from '../pages/revenuemanagement/adminvendorpayment/ViewDetailedRevenueReportsByVendor'
import { InvoiceWiseVendorPaymentManagementTwo } from '../pages/revenuemanagement/vendorpaymentmanagement/InvoiceWiseVendorPaymentManagementtwo'
import { ViewMaps } from '../pages/maps/ViewMaps'
import { ViewCancelledBookings } from '../pages/refundsandpayments/ViewCancelledBookings'
import ViewQQS from '../pages/qqs/ViewQQS'
import ViewMxikkodi from '../pages/mxikkodi/ViewMxikkodi'
import ViewOIchovBirligi from '../pages/oIchovbirligi/ViewOIchovBirligi'
import { ViewHelpAndSupport } from '../pages/helpandsupportmanagement/ViewHelpAndSupport'
import { Tr } from '../../_metronic/i18n/Tr'
import ViewTicketSubjects from '../pages/subjecttickets/ViewTicketSubjects'
import { ViewRatingAndReview } from '../pages/ratingandreviews/ViewRatingAndReview'
import { ViewCarRentalBooking } from '../pages/bookingcarrental/ViewCarRentalBookings'
import { ViewCarBookingDetails } from '../pages/bookingcarrental/ViewCarBookingDetails'
import { ChatInner } from '../pages/chat/ChatInner'
import ViewActivityLog from '../pages/activitylog/ViewActivityLog'
import BookingAnalytics from '../pages/analytics/BookingAnalytics'
import SatisfactionRatings from '../pages/analytics/SatisfactionRatings'
import Demographics from '../pages/analytics/Demographics'
import OccupancyRates from '../pages/analytics/OccupancyRates'
import { ViewAccommodationContract } from '../pages/hotelmanagement/ViewAccommodationContract'
import { ViewRestaurantContract } from '../pages/restaurantmanagement/ViewRestaurantContract'
import { ViewSpaceRentalContract } from '../pages/spacerentalmanagement/ViewSpaceRentalContract'
import { ViewTourPackageContract } from '../pages/tourpackagemanagement/ViewTourPackageContract'
import { ViewCarRentalContract } from '../pages/transportationmanagement/ViewCarRentalContract'

import { useMenuContext } from '../pages/contexts/MenuContext'
import { DashboardWrapper } from '../pages/dashboard/DashboardWrapper'
import { ViewReferrals } from '../pages/referrals/ViewReferrals'
import { ViewAmbassadors } from '../pages/referrals/ViewAmbassadors'
import { ViewAmbassadorsReferrals } from '../pages/referrals/ViewAmbassadorsReferrals'
import { ViewInsayrCommissionFees } from '../pages/revenuemanagement/settings/ViewInsayrCommissionFees'
import { ViewBookingAutoRejectTimer } from '../pages/revenuemanagement/settings/ViewBookingAutoRejectTimer'
import ViewCancellationReason from '../pages/revenuemanagement/settings/ViewCancellationReason'
import { AddRoles } from '../pages/roleandaccess/roles/AddRoles'
import ViewRoles from '../pages/roleandaccess/roles/ViewRoles'
import ViewSupportAdmin from '../pages/roleandaccess/supportadmin/ViewSupportAdmin'
import { ViewSupportSettings } from '../pages/revenuemanagement/supportsettings/ViewSupportSettings'
import { ViewReferralSettings } from '../pages/revenuemanagement/settings/ViewReferralSettings'
import { ViewCouponPrecautions } from '../pages/revenuemanagement/settings/ViewCouponPrecautions'
import ExploreCategories from '../pages/explore/ExploreCategories'
import { UserPosts } from '../pages/explore/user/UserPosts'
import { PostManagement } from '../pages/explore/PostManagement'
import { ReportedUsers } from '../pages/explore/user/ReportedUsers'
import { ReportedPosts } from '../pages/explore/ReportedPosts'
import UserDetails from '../pages/explore/user/UserDetails'
import { EditPost } from '../pages/explore/user/EditPost'
import { ViewBannerSettings } from '../pages/advertisementmanagement/ViewBannerSettings'
import { BannerAdvertisements } from '../pages/advertisementmanagement/BannerAdvertisements'
import { ViewBannerAdvertisementDetail } from '../pages/advertisementmanagement/ViewBannerAdvertisementDetail'
import { AdsImpressions } from '../pages/advertisementmanagement/AdsImpressions'
import { VendorSpendInsights } from '../pages/advertisementmanagement/VendorSpendInsights'
import { VendorAdsList } from '../pages/advertisementmanagement/VendorAdsList'
import { RevenueByPlacements } from '../pages/advertisementmanagement/RevenueByPlacements'
import { AddEditAd } from '../pages/advertisementmanagement/addeditad/AddEditAd'
// Search Ads
import { ViewSearchAdSettings } from '../pages/sponsermanagement/ViewSearchAdSettings'
import { SearchAdvertisements } from '../pages/sponsermanagement/SearchAdvertisements'
import { ViewSearchAdvertisementDetail } from '../pages/sponsermanagement/ViewSearchAdvertisementDetail'
import { SearchAdImpression } from '../pages/sponsermanagement/SearchAdImpression'
import { VendorAdSpends } from '../pages/sponsermanagement/VendorAdSpends'
import { VendorSearchAdsList } from '../pages/sponsermanagement/VendorSearchAdsList'
import { RevenueByCategory } from '../pages/sponsermanagement/RevenueByCategory'
import { AddEditSearchAd } from '../pages/sponsermanagement/addeditsearchad/AddEditSearchAd'
// AdminRoutes

const PrivateRoutes = () => {
  let t = Tr()
  const { allowedPaths, isMenuLoaded } = useMenuContext()

  const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'))
  const breadCrumbs = (title: any, path: any) => {
    return [
      {
        title: title,
        path: path,
        isSeparator: false,
        isActive: false,
      },
    ]
  }

  return (
    // key={isSuperAdmin}
    <Routes>
      {isMenuLoaded ? (
        <Route element={<MasterLayout />}>
          <>
            <Route path='auth/*' element={<Navigate to='/dashboard' />} />``

            {allowedPaths.includes('../viewhotels/') && (
              <>
                <Route path='addhotelbasicinfo' element={<AddHotelBasicInfo />} />
                <Route path='addhotellocation' element={<AddHotelLocation />} />
                <Route path='addhoteldetails' element={<AddHotelDetails />} />
                <Route path='viewrooms' element={<ViewRooms />} />
                <Route path='viewroomslist' element={<ViewRoomsList />} />
                <Route path='addhotelphotos' element={<AddHotelPhotos />} />
                <Route path='addhotelfacilities' element={<AddHotelFacilities />} />
                <Route path='addhotelpolicies' element={<AddHotelPolicies />} />
                <Route path='addhotelfinance' element={<AddHotelFinance />} />
                <Route path='viewhotels' element={<ViewHotels />} />
                <Route
                  path='hoteloverview'
                  element={
                    <SuspensedView>
                      <PageTitle breadcrumbs={breadCrumbs('Room', 'viewrooms')}>
                        {t('Accommodation Overview')}
                      </PageTitle>
                      <HotelOverview />
                    </SuspensedView>
                  }
                />
                <Route
                  path='viewaccommodationcontract'
                  element={
                    <SuspensedView>
                      <PageTitle breadcrumbs={breadCrumbs('Room', 'viewrooms')}>
                        {t('Accommodation Contract')}
                      </PageTitle>
                      <ViewAccommodationContract />
                    </SuspensedView>
                  }
                />
              </>
            )}

            {allowedPaths.includes('../viewrestaurants/') && (
              <>
                <Route path='addrestaurantbasicinfo' element={<AddRestaurantBasicInfo />} />
                <Route path='addrestaurantlocation' element={<AddRestaurantLocation />} />
                <Route path='addrestaurantdetails' element={<AddRestaurantDetails />} />
                <Route path='addrestaurantmenu' element={<AddRestaurantMenu />} />
                <Route path='addrestaurantphotos' element={<AddRestaurantPhotos />} />
                <Route path='addrestaurantfacilities' element={<AddRestaurantFacilities />} />
                <Route path='addrestaurantavailability' element={<AddRestaurantAvailability />} />
                <Route path='addrestaurantpolicies' element={<AddRestaurantPolicies />} />
                <Route path='addrestaurantfinance' element={<AddRestaurantFinance />} />
                <Route path='viewrestaurants' element={<ViewRestaurant />} />
                <Route
                  path='restaurantoverview'
                  element={
                    <SuspensedView>
                      <PageTitle breadcrumbs={breadCrumbs('Room', 'viewrooms')}>
                        {t('Restaurnat Overview')}
                      </PageTitle>
                      <RestaurantOverview />
                    </SuspensedView>
                  }
                />
                {/* <Route
                  path='viewrestaurantcontract'
                  element={
                    <SuspensedView>
                      <PageTitle breadcrumbs={breadCrumbs('Room', 'viewrooms')}>
                        {t('Restaurant Contract')}
                      </PageTitle>
                      <ViewRestaurantContract />
                    </SuspensedView>
                  }
                /> */}
              </>
            )}

            {allowedPaths.includes('../viewspacerentals/') && (
              <>
                <Route path='viewspacerentals' element={<ViewSpaceRentals />} />
                <Route path='addspacebasicinfo' element={<AddSpaceBasicInfo />} />
                <Route path='addspacelocation' element={<AddSpaceLocation />} />
                <Route path='addspacedetails' element={<AddSpaceDetails />} />
                <Route path='viewrentablespaces' element={<ViewRentableSpaces />} />
                <Route path='addspacephotos' element={<AddSpacePhotos />} />
                <Route path='addspacefacilities' element={<AddSpaceFacilities />} />
                <Route path='addspaceavailability' element={<AddSpaceAvailability />} />
                <Route path='addspacepolicies' element={<AddSpacePolicies />} />
                <Route path='addspacefinance' element={<AddSpaceFinance />} />
                <Route
                  path='spacerentaloverview'
                  element={
                    <SuspensedView>
                      <PageTitle breadcrumbs={breadCrumbs('Room', 'viewrooms')}>
                        {t('Space Rental Overview')}
                      </PageTitle>
                      <SpaceRentalOverview />
                    </SuspensedView>
                  }
                />
                <Route
                  path='viewrentablespacelist'
                  element={
                    <SuspensedView>
                      <PageTitle breadcrumbs={breadCrumbs('Room', 'viewrooms')}>
                        {t('Rentable Space List')}
                      </PageTitle>
                      <ViewRentableSpaceList />
                    </SuspensedView>
                  }
                />
                <Route
                  path='viewspacerentalcontract'
                  element={
                    <SuspensedView>
                      <PageTitle breadcrumbs={breadCrumbs('Room', 'viewrooms')}>
                        {t('Space Rental Contract')}
                      </PageTitle>
                      <ViewSpaceRentalContract />
                    </SuspensedView>
                  }
                />
                <Route
                  path='rentablespaceoverview'
                  element={
                    <SuspensedView>
                      <PageTitle breadcrumbs={breadCrumbs('Room', 'viewrooms')}>
                        {t('Rentable Space Overview')}
                      </PageTitle>
                      <RentableSpaceOverview />
                    </SuspensedView>
                  }
                />
                <Route
                  path='roomoverview'
                  element={
                    <SuspensedView>
                      <PageTitle breadcrumbs={breadCrumbs('Room', 'viewrooms')}>
                        {t('Room Over View')}
                      </PageTitle>
                      <RoomOverview />
                    </SuspensedView>
                  }
                />
              </>
            )}

            {allowedPaths.includes('../viewtourpackages/') && (
              <>
                <Route path='viewtourpackages' element={<ViewTourPackages />} />
                <Route path='addtourpackagebasicinfo' element={<AddTourPackageBasicInfo />} />
                <Route path='addtourpackagelocation' element={<AddTourPackageLocation />} />
                <Route path='viewtours' element={<ViewTours />} />
                <Route path='toursoverview' element={<ToursOverview />} />
                <Route path='toursimages' element={<ToursImages />} />
                <Route path='addtourpackagephotos' element={<AddTourPackagePhotos />} />
                <Route path='addtourpackagepolicies' element={<AddTourPackagePolicies />} />
                <Route path='addtourpackagefinance' element={<AddTourPackageFinance />} />
                <Route path='tourpackageoverview' element={<TourPackageOverview />} />
                <Route path='tourpackageimages' element={<TourPackageImages />} />
                <Route path='viewtouslist' element={<ViewToursList />} />
                <Route
                  path='viewtourpackagecontract'
                  element={
                    <SuspensedView>
                      <PageTitle breadcrumbs={breadCrumbs('Room', 'viewrooms')}>
                        {t('Tour Contract')}
                      </PageTitle>
                      <ViewTourPackageContract />
                    </SuspensedView>
                  }
                />
              </>
            )}

            {allowedPaths.includes('../viewcarrentals/') && (
              <>
                <Route path='viewcarrentals' element={<ViewCarRentals />} />
                <Route path='addcarrentalbasicinfo' element={<AddCarRentalBasicInfo />} />
                <Route path='addcarrentallocation' element={<AddCarRentalLocation />} />
                <Route path='viewcars' element={<ViewCars />} />
                <Route path='vehicleoverview' element={<VehicleOverview />} />
                <Route path='addcarrentalphotos' element={<AddCarRentalPhotos />} />
                <Route path='addcarrentalinsurance' element={<AddCarRentalInsurance />} />
                <Route path='addcarrentaldocuments' element={<AddCarRentalDocuments />} />
                <Route path='addcarrentalavailability' element={<AddCarRentalAvailability />} />
                <Route
                  path='addcarrentalpickupordropoffinfo'
                  element={<AddCarRentalPickupOrDropoffInfo />}
                />
                <Route path='addcarrentalpolicies' element={<AddCarRentalPolicies />} />
                <Route path='addcarrentalfinance' element={<AddCarRentalFinance />} />
                <Route path='carrentaloverview' element={<CarRentalOverview />} />
                <Route path='viewcarslist' element={<ViewCarsList />} />
                <Route
                  path='viewcarrentalcontract'
                  element={
                    <SuspensedView>
                      <PageTitle breadcrumbs={breadCrumbs('Room', 'viewrooms')}>
                        {t('Car Rental Contract')}
                      </PageTitle>
                      <ViewCarRentalContract />
                    </SuspensedView>
                  }
                />
              </>
            )}

            {allowedPaths.includes('../viewhotelbooking/') && (
              <>
                <Route
                  path='viewhotelbooking'
                  element={
                    <SuspensedView>
                      <PageTitle>{t('Accommodation Bookings')}</PageTitle>
                      <ViewHotelBooking />
                    </SuspensedView>
                  }
                />
                <Route path='viewhotelbookingdetails' element={<ViewHotelBookingDetails />} />

                <Route path='edithotelbookingdetails' element={<EditHotelBookingDetails />} />
              </>
            )}

            {allowedPaths.includes('../viewspacerentalbooking/') && (
              <>
                <Route
                  path='viewspacerentalbooking'
                  element={
                    <SuspensedView>
                      <PageTitle>{t('Space Rental Bookings')}</PageTitle>
                      <ViewSpaceRentalBooking />
                    </SuspensedView>
                  }
                />
                <Route path='editspacebookingdetails' element={<EditSpaceBookingDetails />} />

                <Route path='viewspacebookingdetails' element={<ViewSpaceBookingDetails />} />
              </>
            )}

            {allowedPaths.includes('../viewcarrentalbookings/') && (
              <>
                <Route
                  path='viewcarrentalbookings'
                  element={
                    <SuspensedView>
                      <PageTitle>{t('Car Rental Bookings')}</PageTitle>
                      <ViewCarRentalBooking />
                    </SuspensedView>
                  }
                />

                <Route path='viewcarbookingdetails' element={<ViewCarBookingDetails />} />
              </>
            )}

            {allowedPaths.includes('../viewtourbooking/') && (
              <>
                <Route
                  path='viewtourbooking'
                  element={
                    <SuspensedView>
                      <PageTitle>{t('Tour Bookings')}</PageTitle>
                      <ViewTourBooking />
                    </SuspensedView>
                  }
                />
                <Route path='viewtourbookingdetails' element={<ViewTourBookingDetails />} />

                <Route path='edittourbookingdetails' element={<EditTourBookingDetails />} />
              </>
            )}

            {allowedPaths.includes('../viewsettings/') && (
              <Route
                path='viewsettings'
                element={
                  <SuspensedView>
                    <AdminCommission />
                  </SuspensedView>
                }
              />
            )}


            {allowedPaths.includes('../viewinsayrcommissionfees/') && (
              <Route
                path='viewinsayrcommissionfees'
                element={
                  <SuspensedView>
                    <ViewInsayrCommissionFees />
                  </SuspensedView>
                }
              />
            )}

            {allowedPaths.includes('../viewreferralsettings/') && (
              <Route
                path='viewreferralsettings'
                element={
                  <SuspensedView>
                    <ViewReferralSettings />
                  </SuspensedView>
                }
              />
            )}
            {/* ── Banner Ads Routes ── */}
            {allowedPaths.includes('../viewbannersettings/') && (
              <Route
                path='viewbannersettings'
                element={
                  <SuspensedView>
                    <PageTitle>{t('Banner Settings')}</PageTitle>
                    <ViewBannerSettings />
                  </SuspensedView>
                }
              />
            )}
            {allowedPaths.includes('../viewbanneradvertisements/') && (
              <>
                <Route
                  path='viewbanneradvertisements'
                  element={
                    <SuspensedView>
                      <PageTitle>{t('Banner Advertisements')}</PageTitle>
                      <BannerAdvertisements />
                    </SuspensedView>
                  }
                />
                <Route
                  path='banneradvertisement/view'
                  element={
                    <SuspensedView>
                      <PageTitle>{t('Banner Advertisement Detail')}</PageTitle>
                      <ViewBannerAdvertisementDetail />
                    </SuspensedView>
                  }
                />
                <Route
                  path='banneradvertisement/addedit'
                  element={
                    <SuspensedView>
                      <PageTitle>{t('Add/Edit Banner Advertisement')}</PageTitle>
                      <AddEditAd />
                    </SuspensedView>
                  }
                />
              </>
            )}
            {allowedPaths.includes('../viewadsimpressions/') && (
              <Route
                path='viewadsimpressions'
                element={
                  <SuspensedView>
                    <PageTitle>{t('Ads Impressions')}</PageTitle>
                    <AdsImpressions />
                  </SuspensedView>
                }
              />
            )}
            {allowedPaths.includes('../viewvendorspendinsights/') && (
              <>
                <Route
                  path='viewvendorspendinsights'
                  element={
                    <SuspensedView>
                      <PageTitle>{t('Vendor Ad Spends')}</PageTitle>
                      <VendorSpendInsights />
                    </SuspensedView>
                  }
                />
                <Route
                  path='vendoradslist'
                  element={
                    <SuspensedView>
                      <PageTitle>{t('Vendor Ads')}</PageTitle>
                      <VendorAdsList />
                    </SuspensedView>
                  }
                />
              </>
            )}
            {allowedPaths.includes('../viewrevenuebyplacements/') && (
              <Route
                path='viewrevenuebyplacements'
                element={
                  <SuspensedView>
                    <PageTitle>{t('Revenue By Placements')}</PageTitle>
                    <RevenueByPlacements />
                  </SuspensedView>
                }
              />
            )}

            {/* ── Search Ads Routes ── */}
            {allowedPaths.includes('../viewsearchadsettings/') && (
              <Route
                path='viewsearchadsettings'
                element={
                  <SuspensedView>
                    <PageTitle>{t('Search Ad Settings')}</PageTitle>
                    <ViewSearchAdSettings />
                  </SuspensedView>
                }
              />
            )}
            {allowedPaths.includes('../viewsearchadvertisements/') && (
              <>
                <Route
                  path='viewsearchadvertisements'
                  element={
                    <SuspensedView>
                      <PageTitle>{t('Search Advertisements')}</PageTitle>
                      <SearchAdvertisements />
                    </SuspensedView>
                  }
                />
                <Route
                  path='searchadvertisement/view'
                  element={
                    <SuspensedView>
                      <PageTitle>{t('Search Advertisement Detail')}</PageTitle>
                      <ViewSearchAdvertisementDetail />
                    </SuspensedView>
                  }
                />
                <Route
                  path='searchadvertisement/addedit'
                  element={
                    <SuspensedView>
                      <PageTitle>{t('Add/Edit Search Advertisement')}</PageTitle>
                      <AddEditSearchAd />
                    </SuspensedView>
                  }
                />
              </>
            )}
            {allowedPaths.includes('../viewsearchadimpression/') && (
              <Route
                path='viewsearchadimpression'
                element={
                  <SuspensedView>
                    <PageTitle>{t('Search Ad Impressions')}</PageTitle>
                    <SearchAdImpression />
                  </SuspensedView>
                }
              />
            )}
            {allowedPaths.includes('../viewvendoradspends/') && (
              <>
                <Route
                  path='viewvendoradspends'
                  element={
                    <SuspensedView>
                      <PageTitle>{t('Vendor Ad Spends')}</PageTitle>
                      <VendorAdSpends />
                    </SuspensedView>
                  }
                />
                <Route
                  path='vendorsearchadslist'
                  element={
                    <SuspensedView>
                      <PageTitle>{t('Vendor Search Ads')}</PageTitle>
                      <VendorSearchAdsList />
                    </SuspensedView>
                  }
                />
              </>
            )}
            {allowedPaths.includes('../viewrevenuebycategory/') && (
              <Route
                path='viewrevenuebycategory'
                element={
                  <SuspensedView>
                    <PageTitle>{t('Revenue By Category')}</PageTitle>
                    <RevenueByCategory />
                  </SuspensedView>
                }
              />
            )}

            {allowedPaths.includes('../viewcouponprecautions/') && (
              <Route
                path='viewcouponprecautions'
                element={
                  <SuspensedView>
                    <ViewCouponPrecautions />
                  </SuspensedView>
                }
              />
            )}
         
            {allowedPaths.includes('../viewsupportsettings/') && (
              <Route
                path='viewsupportsettings'
                element={
                  <SuspensedView>
                    <ViewSupportSettings />
                  </SuspensedView>
                }
              />
            )}
            {allowedPaths.includes('../viewbookingautorejecttimer/') && (
              <Route
                path='viewbookingautorejecttimer'
                element={
                  <SuspensedView>
                    <ViewBookingAutoRejectTimer />
                  </SuspensedView>
                }
              />
            )}

            {allowedPaths.includes('../viewqqs/') && (
              <Route
                path='viewqqs'
                element={
                  <SuspensedView>
                    <PageTitle>{t('View QQS')}</PageTitle>
                    <ViewQQS />
                  </SuspensedView>
                }
              />
            )}
            {allowedPaths.includes('../viewroles') && (
              <Route
                path='viewroles'
                element={
                  <SuspensedView>
                    <PageTitle>{t('View Roles & Right')}</PageTitle>
                    <ViewRoles />
                  </SuspensedView>
                }
              />
            )}
            <Route
              path='addrole'
              element={
                <SuspensedView>
                  <PageTitle>{t('Add Roles & Right')}</PageTitle>
                  <AddRoles />
                </SuspensedView>
              }
            />

            {allowedPaths.includes('../viewmxikkodi/') && (
              <Route
                path='viewmxikkodi'
                element={
                  <SuspensedView>
                    <PageTitle>{t('View Mxikkodi')}</PageTitle>
                    <ViewMxikkodi />
                  </SuspensedView>
                }
              />
            )}
            {allowedPaths.includes('../viewoIchovBirligi/') && (
              <Route
                path='viewoIchovBirligi'
                element={
                  <SuspensedView>
                    <PageTitle>{t('View OIchovBirligi')}</PageTitle>
                    <ViewOIchovBirligi />
                  </SuspensedView>
                }
              />
            )}

            {allowedPaths.includes('../viewcoupon/') && (
              <Route
                path='viewcoupon'
                element={
                  <SuspensedView>
                    <PageTitle>{t('View Coupons')}</PageTitle>
                    <ViewCoupon />
                  </SuspensedView>
                }
              />
            )}
            {allowedPaths.includes('../viewadminvendorpayment/') && (
              <>
                <Route
                  path='viewadminvendorpayment'
                  element={
                    <SuspensedView>
                      <PageTitle>{t('Revenue Breakdown')}</PageTitle>
                      <ViewAdminVendorPayment />
                    </SuspensedView>
                  }
                />
                <Route
                  path='viewadminvendorpaymentdetails'
                  element={
                    <SuspensedView>
                      <PageTitle>{t('Revenue Breakdown Details')}</PageTitle>
                      <ViewAdminVendorPaymetDetail />
                    </SuspensedView>
                  }
                />
              </>
            )}

            {allowedPaths.includes('viewvendorpaymentmanagement') && (
              <>
                <Route
                  path='viewvendorpaymentmanagement'
                  element={
                    <SuspensedView>
                      <PageTitle>{t('View Vendor Payment Management')}</PageTitle>
                      <ViewVendorPaymentManagement />
                    </SuspensedView>
                  }
                />
                <Route
                  path='invoicewisevendorpaymentmanagement'
                  element={
                    <SuspensedView>
                      <PageTitle>{t('View Vendor Payment Management Invoice Wise')}</PageTitle>
                      <InvoiceWiseVendorPaymentManagement />
                    </SuspensedView>
                  }
                />
                <Route
                  path='invoicedatavendorwise'
                  element={
                    <SuspensedView>
                      <PageTitle>{t('View Vendor Payment Management Property Wise')} </PageTitle>
                      <Invoicedatavendorwise />
                    </SuspensedView>
                  }
                />
                <Route
                  path='invoicewisevendorsbooking'
                  element={
                    <SuspensedView>
                      <PageTitle>{t('View Vendor Booking Invoice Wise')}</PageTitle>
                      <InvoiceWiseVendorPaymentManagementTwo />
                    </SuspensedView>
                  }
                />
              </>
            )}

            <Route
              path='viewdetailedrevenuereportsbyvendor'
              element={
                <SuspensedView>
                  <PageTitle>View Detailed Revenue Reports (By Vendor) </PageTitle>
                  <ViewDetailedRevenueReportsByVendor />
                </SuspensedView>
              }
            />

            {allowedPaths.includes('../viewratingandreview') && (
              <Route
                path='viewratingandreview'
                element={
                  <SuspensedView>
                    <PageTitle>{t("View Rating & Reviews")}</PageTitle>
                    <ViewRatingAndReview />
                  </SuspensedView>
                }
              />
            )}

            {allowedPaths.includes('viewmaps') && <Route path='viewmaps' element={<ViewMaps />} />}
            <Route path='viewcategorywiseearning' element={<ViewCategoryWiseEarning />} />

            {allowedPaths.includes('../viewvendorwiseearning/') && (
              <Route path='viewvendorwiseearning' element={<ViewVendorWiseEarning />} />
            )}

            {allowedPaths.includes('viewtotalrevenuechart') && (
              <Route path='viewtotalrevenuechart' element={<ViewTotalRevenueChart />} />
            )}


            {allowedPaths.includes('../viewambassadors') && (
                    <>
              <Route path='viewambassadors' element={<ViewAmbassadors />} />
            <Route path='viewambassadorsreferrals' element={<ViewAmbassadorsReferrals />} />
                    </>

            )}



            {allowedPaths.includes('viewcategorywiseearningbyyearmonth') && (
              <Route
                path='viewcategorywiseearningbyyearmonth'
                element={<ViewCategoryWiseEarningByYearMonth />}
              />
            )}

            {allowedPaths.includes('../viewreferrals') && (
         
              <Route path='viewreferrals' element={<ViewReferrals />} />

            )}

            {allowedPaths.includes('viewcancelledbooking') && (
              <Route
                path='viewcancelledbooking'
                element={
                  <SuspensedView>
                    <PageTitle>{t('View Cancelled Bookings')} </PageTitle>
                    <ViewCancelledBookings />
                  </SuspensedView>
                }
              />
            )}
            <Route
              path='crafted/pages/profile/*'
              element={
                <SuspensedView>
                  <ProfilePage />
                </SuspensedView>
              }
            />

            <Route
              path='crafted/account/*'
              element={
                <SuspensedView>
                  <AccountPage />
                </SuspensedView>
              }
            />

            <Route
              path='inbox'
              element={
                <SuspensedView>
                  <PageTitle breadcrumbs={breadCrumbs('Message', 'inbox')}>Inbox</PageTitle>
                  {/* <Inbox /> */}
                </SuspensedView>
              }
            />
            <Route
              path='compose'
              element={
                <SuspensedView>
                  <PageTitle breadcrumbs={breadCrumbs('Message', 'inbox')}>Compose</PageTitle>
                  {/* <Compose /> */}
                </SuspensedView>
              }
            />
            <Route
              path='replay'
              element={
                <SuspensedView>
                  <PageTitle breadcrumbs={breadCrumbs('Message', 'inbox')}>Replay</PageTitle>
                  {/* <Replay /> */}
                </SuspensedView>
              }
            />

            <Route
              path='viewadmin'
              element={
                <SuspensedView>
                  <PageTitle breadcrumbs={breadCrumbs('Admin', 'viewadmin')}>View Admin</PageTitle>
                  <AdminPage />
                </SuspensedView>
              }
            />

            {allowedPaths.includes('../viewuser/') && (
              <Route
                path='viewuser'
                element={
                  <SuspensedView>
                    <PageTitle breadcrumbs={breadCrumbs('User', 'viewuser')}>
                      {t('View User')}
                    </PageTitle>
                    <UserPage />
                  </SuspensedView>
                }
              />
            )}
            {allowedPaths.includes('../viewuser/') && (
              
              <Route
                path='/explore/user/'
                element={
                  <SuspensedView>
                    <PageTitle breadcrumbs={breadCrumbs('User', 'viewuser')}>
                      {t('View User Posts')}
                    </PageTitle>
                    <UserPosts />
                  </SuspensedView>
                }
              />
            )}
            {allowedPaths.includes('../viewuser/') && (
              
              <Route
                path='/editpost/'
                element={
                  <SuspensedView>
                    <PageTitle breadcrumbs={breadCrumbs('User', 'editpost')}>
                      {t('Edit User Post')}
                    </PageTitle>
                    <EditPost />
                  </SuspensedView>
                }
              />
            )}

            {allowedPaths.includes('../viewvendor/') && (
              <Route
                path='viewvendor/*'
                element={
                  <SuspensedView>
                    <PageTitle breadcrumbs={breadCrumbs('Vendor', 'viewvendor')}>
                      {t('View Vendor')}
                    </PageTitle>
                    <VendorsPage />
                  </SuspensedView>
                }
              />
            )}

            <Route
              path='userlist'
              element={
                <SuspensedView>
                  <PageTitle breadcrumbs={breadCrumbs('Category', 'viewcategory')}>
                    {t('View Category')}
                  </PageTitle>
                  {/* <UsersListWrapper /> */}
                </SuspensedView>
              }
            />
            <Route
              path='profile/*'
              element={
                <SuspensedView>
                  <PageTitle breadcrumbs={breadCrumbs('Profile', 'profile')}>
                    View Profile
                  </PageTitle>
                  <AccountPage />
                </SuspensedView>
              }
            />

            {allowedPaths.includes('../viewcategory/') && (
              <Route
                path='viewcategory'
                element={
                  <SuspensedView>
                    <PageTitle breadcrumbs={breadCrumbs(t('Services'), 'viewcategory')}>
                      {t('View Services')}
                    </PageTitle>
                    <CategoryPage />
                  </SuspensedView>
                }
              />
            )}

            {allowedPaths.includes('../viewsubcategory/') && (
              <Route
                path='viewsubcategory'
                element={
                  <SuspensedView>
                    <PageTitle breadcrumbs={breadCrumbs(t('Subcategory'), 'viewsubcategory')}>
                      {t('View Subcategory')}
                    </PageTitle>
                    <SubcategoryPage />
                  </SuspensedView>
                }
              />
            )}

            {allowedPaths.includes('../viewticketsubjects') && (
              <Route
                path='viewticketsubjects'
                element={
                  <SuspensedView>
                    <PageTitle breadcrumbs={breadCrumbs(t('Ticket Subjects'), 'viewsubcategory')}>
                      {t('View Ticket Subjects')}
                    </PageTitle>
                    <ViewTicketSubjects />
                  </SuspensedView>
                }
              />
            )}

            <Route
              path='viewtravelleridtype'
              element={
                <SuspensedView>
                  <PageTitle breadcrumbs={breadCrumbs('Traveller Idtype', 'viewsubcategory')}>
                    {t('Traveller Idtype')}
                  </PageTitle>
                  <ViewTravellerIdType />
                </SuspensedView>
              }
            />
            {allowedPaths.includes('../viewinterest/') && (
              <Route
                path='viewinterest'
                element={
                  <SuspensedView>
                    <PageTitle breadcrumbs={breadCrumbs(t('Interest'), 'viewinterest')}>
                      {t('View Interest')}
                    </PageTitle>
                    <InterestPage />
                  </SuspensedView>
                }
              />
            )}
            {allowedPaths.includes('../viewexplorecategories/') && (
              <Route
                path='viewexplorecategories'
                element={
                  <SuspensedView>
                    <PageTitle breadcrumbs={breadCrumbs(t('Explore'), 'viewexplorecategories')}>
                      {t('View Explore Categories')}
                    </PageTitle>
                    <ExploreCategories />
                  </SuspensedView>
                }
              />
            )}
            {allowedPaths.includes('../postmanagement/') && (
              <Route
                path='postmanagement'
                element={
                  <SuspensedView>
                    <PageTitle breadcrumbs={breadCrumbs(t('Explore'), 'postmanagement')}>
                      {t('Post Management')}
                    </PageTitle>
                    <PostManagement />
                  </SuspensedView>
                }
              />
            )}

            {allowedPaths.includes('../viewreportedusers/') && (
              <Route
                path='viewreportedusers'
                element={
                  <SuspensedView>
                    <PageTitle breadcrumbs={breadCrumbs(t('Explore'), 'viewreportedusers')}>
                      {t('Reported Users')}
                    </PageTitle>
                    <ReportedUsers />
                  </SuspensedView>
                }
              />
            )}
            {allowedPaths.includes('../viewreportedusers/') && (
              <Route
                path='viewreportedusers'
                element={
                  <SuspensedView>
                    <PageTitle breadcrumbs={breadCrumbs(t('Explore'), 'viewreportedusers')}>
                      {t('Reported Users')}
                    </PageTitle>
                    <ReportedUsers />
                  </SuspensedView>
                }
              />
            )}

            {/* {allowedPaths.includes('../viewreportedusers/') && (
              <Route
                path='userdetails'
                element={
                  <SuspensedView>
                    <PageTitle breadcrumbs={breadCrumbs(t('Explore'), 'userdetails')}>
                      {t('Reported User Details')}
                    </PageTitle>
                    <UserDetails />
                  </SuspensedView>
                }
              />
            )} */}

            {allowedPaths.includes('../viewreportedposts/') && (
              <Route
                path='viewreportedposts'
                element={
                  <SuspensedView>
                    <PageTitle breadcrumbs={breadCrumbs(t('Explore'), 'viewreportedposts')}>
                      {t('Reported Posts')}
                    </PageTitle>
                    <ReportedPosts />
                  </SuspensedView>
                }
              />
            )}

            {allowedPaths.includes('viewcancellationreasons') && (
              <Route
                path='viewcancellationreasons'
                element={
                  <SuspensedView>
                    <PageTitle
                      breadcrumbs={breadCrumbs(t('Cancellations'), 'View Cancellation Reasons')}
                    >
                      {t('View Cancellation Reasons')}
                    </PageTitle>
                    <ViewCancellationReason />
                  </SuspensedView>
                }
              />
            )}

            {allowedPaths.includes('../viewsupportadmins') && (
              <Route
                path='viewsupportadmins'
                element={
                  <SuspensedView>
                    <PageTitle breadcrumbs={breadCrumbs(t('Support Admin'), 'viewcategory')}>
                      {t('View Support Admin')}
                    </PageTitle>
                    <ViewSupportAdmin />
                  </SuspensedView>
                }
              />
            )}

            <Route
              path='viewtourtype'
              element={
                <SuspensedView>
                  <PageTitle breadcrumbs={breadCrumbs('Tour Type', 'viewtourtype')}>
                    {t('View Tour Type')}
                  </PageTitle>
                  <TourTypePage />
                </SuspensedView>
              }
            />

            <Route
              path='roomimages'
              element={
                <SuspensedView>
                  <PageTitle breadcrumbs={breadCrumbs('Room', 'viewrooms')}>
                    {t('Room Images')}
                  </PageTitle>
                  <RoomImages />
                </SuspensedView>
              }
            />

            <Route
              path='restaurantimages'
              element={
                <SuspensedView>
                  <PageTitle breadcrumbs={breadCrumbs('Room', 'viewrooms')}>
                    {t('Restaurnat Images')}
                  </PageTitle>
                  <RestaurantImages />
                </SuspensedView>
              }
            />

            <Route
              path='spaceimages'
              element={
                <SuspensedView>
                  <PageTitle breadcrumbs={breadCrumbs('Room', 'viewrooms')}>
                    {t('Space Rental Images')}
                  </PageTitle>
                  <SpaceImages />
                </SuspensedView>
              }
            />

            <Route
              path='rentablespaceimages'
              element={
                <SuspensedView>
                  <PageTitle breadcrumbs={breadCrumbs('Room', 'viewrooms')}>
                    {t('Rentable Space Images')}
                  </PageTitle>
                  <RentableSpaceImages />
                </SuspensedView>
              }
            />

            <Route
              path='loyaltyprogram'
              element={
                <SuspensedView>
                  <PageTitle breadcrumbs={breadCrumbs('loyaltyprogram', 'loyaltyprogram')}>
                    {t('Loyalty Program')}
                  </PageTitle>
                  <LoyaltiProgramPage />
                </SuspensedView>
              }
            />

            {allowedPaths.includes('../pointsystem/') && (
              <Route
                path='pointsystem'
                element={
                  <SuspensedView>
                    <PageTitle>{t('Point System')}</PageTitle>
                    <PointSystem />
                  </SuspensedView>
                }
              />
            )}

            {allowedPaths.includes('../levelsystem/') && (
              <Route
                path='levelsystem'
                element={
                  <SuspensedView>
                    <PageTitle>{t('Levels System')}</PageTitle>
                    <LevelsPoint />
                  </SuspensedView>
                }
              />
            )}
            {allowedPaths.includes('../badgesystem/') && (
              <Route
                path='badgesystem'
                element={
                  <SuspensedView>
                    <PageTitle>{t('Badge System')}</PageTitle>
                    <BadgeSystem />
                  </SuspensedView>
                }
              />
            )}

            {allowedPaths.includes('../accommodation/') && (
              <Route
                path='accommodation/*'
                element={
                  <SuspensedView>
                    <PageTitle>{t('Accommodation')}</PageTitle>

                    <Accommodation />
                  </SuspensedView>
                }
              />
            )}

            {allowedPaths.includes('cafeandresturant/') && (
              <Route
                path='cafeandresturant/*'
                element={
                  <SuspensedView>
                    <PageTitle>{t('Cafe and Resturants')}</PageTitle>

                    <CafeAndResturant />
                  </SuspensedView>
                }
              />
            )}

            {allowedPaths.includes('spacerentals/') && (
              <Route
                path='spacerentals/*'
                element={
                  <SuspensedView>
                    <PageTitle>{t('Space And Rentals')}</PageTitle>

                    <SpaceRentals />
                  </SuspensedView>
                }
              />
            )}

            {allowedPaths.includes('tourpackages/') && (
              <Route
                path='tourpackages/*'
                element={
                  <SuspensedView>
                    <PageTitle>{t('Tour Packages')}</PageTitle>

                    <TourPackages />
                  </SuspensedView>
                }
              />
            )}

            {allowedPaths.includes('carentals/') && (
              <Route
                path='carentals/*'
                element={
                  <SuspensedView>
                    <PageTitle>{t('Car Rentals')}</PageTitle>

                    <CarRentals />
                  </SuspensedView>
                }
              />
            )}

            {allowedPaths.includes('flighttickets/') && (
              <Route
                path='flighttickets/*'
                element={
                  <SuspensedView>
                    <PageTitle>{t('Flight Tickets')}</PageTitle>

                    <FlightTickets />
                  </SuspensedView>
                }
              />
            )}

            {allowedPaths.includes('traintickets/') && (
              <Route
                path='traintickets/*'
                element={
                  <SuspensedView>
                    <PageTitle>{t('Train Tickets')}</PageTitle>

                    <TrainTickets />
                  </SuspensedView>
                }
              />
            )}

            {allowedPaths.includes('leisureandtickets/') && (
              <Route
                path='leisureandtickets/*'
                element={
                  <SuspensedView>
                    <PageTitle>{t('Leisure And Tickets')}</PageTitle>

                    <LeisureAndTickets />
                  </SuspensedView>
                }
              />
            )}
            <Route
              path='dashboard'
              element={
                <>
                  <SuspensedView>
                    <PageTitle breadcrumbs={breadCrumbs('Dashboard', 'dashboard')}>
                      Dashboard
                    </PageTitle>
                    <DashboardWrapper />
                  </SuspensedView>
                </>
              }
            />
            {allowedPaths.includes('../viewhelpandsupport/') && (
              <>
                <Route
                  path='viewhelpandsupport'
                  element={
                    <SuspensedView>
                      <PageTitle breadcrumbs={breadCrumbs('Help & Support', 'View Help & Support')}>
                        {t('View Help & Support')}
                      </PageTitle>
                      <ViewHelpAndSupport />
                    </SuspensedView>
                  }
                />
                <Route
                  path='chat'
                  element={
                    <SuspensedView>
                      <PageTitle breadcrumbs={breadCrumbs(t('Chat'), 'Private Chat')}>
                        {t('Private Chat')}
                      </PageTitle>
                      <ChatInner />
                    </SuspensedView>
                  }
                />
              </>
            )}

            {allowedPaths.includes('../viewbookinganalytics/') && (
              <Route
                path='viewbookinganalytics'
                element={
                  <SuspensedView>
                    <PageTitle>{t('Booking Analytics')}</PageTitle>
                    <BookingAnalytics />
                  </SuspensedView>
                }
              />
            )}

            {allowedPaths.includes('../viewsatisfactionratings/') && (
              <Route
                path='viewsatisfactionratings'
                element={
                  <SuspensedView>
                    <PageTitle>{t('Satisfaction Ratings')}</PageTitle>
                    <SatisfactionRatings />
                  </SuspensedView>
                }
              />
            )}

            {allowedPaths.includes('../viewoccupancyrates/') && (
              <Route
                path='viewoccupancyrates'
                element={
                  <SuspensedView>
                    <PageTitle>{t('Occupancy Rates')}</PageTitle>
                    <OccupancyRates />
                  </SuspensedView>
                }
              />
            )}

            {allowedPaths.includes('../viewdemographics/') && (
              <Route
                path='viewdemographics'
                element={
                  <SuspensedView>
                    <PageTitle>{t('Demographics')}</PageTitle>
                    <Demographics />
                  </SuspensedView>
                }
              />
            )}
            

            {allowedPaths.includes('../viewactivitylog/') && (
              <Route
                path='viewactivitylog'
                element={
                  <SuspensedView>
                    <PageTitle>{t('Activity Log')}</PageTitle>
                    <ViewActivityLog />
                  </SuspensedView>
                }
              />
            )}

            {/* <Route path='*' element={<Navigate to='/error/404' />} /> */}
          </>
        </Route>
      ) : (
        ''
      )}
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({ children }) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export { PrivateRoutes }
